import React from "react";
import { motion } from "framer-motion";
import { UserCheck, Wallet, Map } from "lucide-react";

const CARDS = [
    {
        icon: UserCheck,
        title: "Human-Validated Recommendation",
        desc: "Hasil pencarian kampus tidak berhenti di sistem. Counselor kami akan membantu validasi pilihanmu.",
    },
    {
        icon: Wallet,
        title: "Budget & ROI Awareness",
        desc: "Kami bantu melihat biaya kuliah, biaya hidup, dan potensi balik modal secara lebih realistis.",
    },
    {
        icon: Map,
        title: "Application Journey Support",
        desc: "Mulai dari shortlist kampus, dokumen, aplikasi, visa, sampai persiapan keberangkatan.",
    },
];

export default function TrustSection() {
    return (
        <section className="bg-[#F8FAFC] py-20 md:py-24" data-testid="trust-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="max-w-3xl mb-12">
                    <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-slate-200 text-xs font-semibold text-[#0A1A2F] mb-5">
                        <span className="w-1.5 h-1.5 bg-[#F5A623] rounded-full" /> KENAPA GANTARI EDU
                    </div>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1A2F] leading-tight tracking-tight">
                        Bukan Sekadar Tools. Setiap Rekomendasi Tetap Divalidasi Manusia.
                    </h2>
                    <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Teknologi kami membantu memetakan pilihan kampus lebih cepat. Namun keputusan akhir tetap dibahas bersama <strong className="text-[#0A1A2F]">Counselor Senior</strong> agar rekomendasinya sesuai dengan nilai, budget, tujuan karier, kondisi keluarga, dan peluang acceptance kamu.
                    </p>
                </div>
                <div className="grid md:grid-cols-3 gap-5 md:gap-6">
                    {CARDS.map((c, i) => {
                        const Icon = c.icon;
                        return (
                            <motion.div
                                key={c.title}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ duration: 0.5, delay: i * 0.08 }}
                                className="bg-white border border-slate-200 rounded-2xl p-7 hover:border-[#F5A623] hover:shadow-lg transition-all"
                                data-testid={`trust-card-${i}`}
                            >
                                <div className="w-11 h-11 rounded-xl bg-[#0A1A2F] flex items-center justify-center mb-5">
                                    <Icon className="w-5 h-5 text-[#F5A623]" />
                                </div>
                                <h3 className="font-display font-semibold text-lg text-[#0A1A2F] leading-snug">{c.title}</h3>
                                <p className="mt-2.5 text-sm text-slate-600 leading-relaxed">{c.desc}</p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
